import "./LottieRendererComponent.scss";
import Lottie from 'lottie-react';
import React, { useRef } from "react";

interface LottieRendererComponentProps {
    animationData: object; // Accepts the Lottie JSON as a prop
}

const LottieRendererComponent = (props: LottieRendererComponentProps) => {
    const { animationData } = props;
    const lottieRef = useRef(null);

    return (
        <Lottie
            lottieRef={lottieRef}
            animationData={animationData}
            loop={true}
            autoplay={true}
            style={{ width: 190, height: 220 }} // Adjust size as needed
        />
    );
};

export default LottieRendererComponent;
